<template>
  <div
    @click="() => {openModal()}">
    <TooltipedBtn
      v-if="mode === 'icon'"
      :color="!$_existSubscription ? 'var(--v-secondary__green_not_active-base)' : 'var(--text-color)'"
      data-qa="entity-subscription"
      :disabled="!currentEntityKey"
      :icon="$_muted ? 'no-notifications' : 'notifications'"
      small-btn
      :text="$t('Common.subscriptionSettings')"
      @click="openModal()"/>
    <MenuItem
      v-else
      class="h11-links"
      data-qa="entity-subscription"
      :icon="$_muted ? 'no-notifications' : 'notifications'"
      :label="$t('Common.subscriptionSettings')"
      @click="openModal()"/>
    <DialogTemplateToolkit
      :dialog="open"
      :first_btn="$t('Common.Apply')"
      :second_btn="$t('Common.Close')"
      :title="$t('Common.subscriptionAndNotifications')"
      :without_first_btn="disableApply"
      @apply="changeState"
      @close="closeModal">
      <template #card-text>
        {{ $t('Common.subscriptonText') }} <b>#{{ value.tenderNumber }} {{ value.title }}</b>
        <div>
          <sCheckbox
            v-model="modelData.subscription"
            class="block mt-2"
            :disabled="loading"
            @change="val => modelData.notifications = val">
            {{ $t('Common.subscription') }}
          </sCheckbox>
          <sCheckbox
            v-model="modelData.notifications"
            class="block mt-2"
            :disabled="loading || !modelData.subscription">
            {{ $t('Common.receiveNotifications') }}
          </sCheckbox>
        </div>
      </template>
    </DialogTemplateToolkit>
  </div>
</template>

<script>
import MenuItem from 'components/common/MenuItem.vue'
import TooltipedBtn from 'components/common/elements/TooltipedBtn.vue'
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'

/**
 * Проверка подписки на события по сущности и изменения статуса этой подписки
 */
import { mapGetters } from 'vuex'
import { innerChatMixin } from 'mixins'
import { debounce } from 'toolkit/utils/util'
import { eventBus } from '@/main'

export default {
  name: 'entitySubscription',
  mixins: [ innerChatMixin ],
  data() {
    return {
      open: false,
      loading: false,
      modelData: {
        subscription: false,
        notifications: false,
      }
    }
  },
  methods: {
    openModal() {
      this.modelData.subscription = this.$_existSubscription
      this.modelData.notifications = this.$_existSubscription ? !this.$_muted : false
      this.open = true
    },
    closeModal() {
      this.open = false
      this.$emit('closeModal')
    },
    changeState: debounce(async function () {
      if (!this.isActiveSignalR) {
        eventBus.$emit('ShowSignalAlert', 'Зміна статусу підписки')
        return
      }
      this.loading = true
      let status
      if (this.modelData.subscription && !this.modelData.notifications) {
        status = this.status.mute
      } else if (!this.$_existSubscription && this.modelData.subscription) {
        status = this.status.subscrible
      } else if (this.$_existSubscription && !this.modelData.subscription) {
        status = this.status.unsubscrible
      } else {
        status = this.status.unmute
      }

      this.$notifier.SendUpdateEventSubscription({
        entity: {
          entityType: this.entityType,
          entityId: this.currentEntityKey
        },
        status: status
      })
      this.loading = false
      this.closeModal()
    }, 250),
  },
  computed: {
    ...mapGetters('notification', [ 'isActiveSignalR', 'accessNotification']),
    disableApply() {
      return this.$_existSubscription === this.modelData.subscription
      && this.modelData.notifications === (this.$_existSubscription ? !this.$_muted : false)
    },
    currentEntityKey() {
      return this.entityKey?.toString()
    },
    entityKey() {
      return this.value?.tenderId
    }
  },
  props: {
    value: {
      type: Object,
      require: true,
    },
    entityType: {
      type: String,
      validator: function (value) {
        return ['Tender'].indexOf(value) !== -1
      },
      default: 'Tender'
    },
    mode: {
      type: String
    }
  },
  components: {
    MenuItem,
    TooltipedBtn,
    DialogTemplateToolkit
  }
}
</script>
<style scoped>
.entity-subscription {
  transition: all 0.4s;
  min-height: 40px;
}
.entity-subscription:hover,
.entity-subscription:focus {
  cursor: pointer;
  background: #ddeceb;
}
</style>
